/**
 * If you're adding an icon
 * please sort alphabetically
 */
import AccountIcon from "@mui/icons-material/AccountCircleOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddIcon from "@mui/icons-material/AddOutlined";
import AlarmIcon from "@mui/icons-material/Alarm";
import AllInclusiveIcon from "@mui/icons-material/AllInclusiveOutlined";
import AnnouncementOutlinedIcon from "@mui/icons-material/AnnouncementOutlined";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import AssignedIcon from "@mui/icons-material/HowToRegOutlined";
import AssignmentTurnedInOutlined from "@mui/icons-material/AssignmentTurnedInOutlined";
import AssistantOutlinedIcon from "@mui/icons-material/AssistantOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesomeOutlined";
import BadgeIcon from "@mui/icons-material/BadgeOutlined";
import BarChartIcon from "@mui/icons-material/Equalizer";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkIconOutlined from "@mui/icons-material/BookmarkBorderOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import CategoryIcon from "@mui/icons-material/CategoryOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ChatIcon from "@mui/icons-material/ChatOutlined";
import ChatBubbleIcon from "@mui/icons-material/ChatBubbleOutline";
import CheckBoxCheckedIcon from "@mui/icons-material/CheckBox";
import CheckBoxIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CheckIcon from "@mui/icons-material/Check";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CircleBlank from "@mui/icons-material/CircleOutlined";
import CircleChecked from "@mui/icons-material/CheckCircleOutline";
import CircleIcon from "@mui/icons-material/Circle";
import CloseIcon from "@mui/icons-material/Close";
import CloseOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DashboardOutlined from "@mui/icons-material/DashboardOutlined";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import DownloadIcon from "@mui/icons-material/FileDownloadOutlined";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import DynamicFormOutlinedIcon from "@mui/icons-material/DynamicFormOutlined";
import EditNoteIcon from "@mui/icons-material/EditNote";
import EditIcon from "@mui/icons-material/EditOutlined";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import EndDateIcon from "@mui/icons-material/EventBusyOutlined";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import FiberManualRecord from "@mui/icons-material/FiberManualRecord"; // a small circle icon
import FilterListIcon from "@mui/icons-material/FilterList";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import GlobeIcon from "@mui/icons-material/LanguageOutlined";
import GridIcon from "@mui/icons-material/GridOn";
import GroupIcon from "@mui/icons-material/GroupsOutlined";
import HandshakeIcon from "@mui/icons-material/HandshakeOutlined";
import HelpIcon from "@mui/icons-material/HelpOutline";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import InsertChartIcon from "@mui/icons-material/InsertChartOutlined";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import LeaderboardIcon from "@mui/icons-material/LeaderboardOutlined";
import LinearScaleRoundedIcon from "@mui/icons-material/LinearScaleRounded";
import LinkIcon from "@mui/icons-material/Link";
import ListOutlined from "@mui/icons-material/ListOutlined";
import LoopOutlined from "@mui/icons-material/LoopOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import Lock from "@mui/icons-material/Lock";
import LockOpen from "@mui/icons-material/LockOpen";
import LockOpenOutlined from "@mui/icons-material/LockOpenOutlined";
import LockOutlined from "@mui/icons-material/LockOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import NoChangeIcon from "@mui/icons-material/Remove";
import NorthWestIcon from "@mui/icons-material/NorthWest";
import NoteIcon from "@mui/icons-material/StickyNote2Outlined";
import NotificationIcon from "@mui/icons-material/NotificationsOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import OpenBookIcon from "@mui/icons-material/AutoStoriesOutlined";
import PauseIcon from "@mui/icons-material/PauseOutlined";
import PersonAddIcon from "@mui/icons-material/PersonAddAltOutlined";
import PersonRemoveIcon from "@mui/icons-material/PersonRemoveOutlined";
import PhoneIcon from "@mui/icons-material/PhoneIphoneOutlined";
import PushPinIcon from "@mui/icons-material/PushPinOutlined";
import PushPinFilledIcon from "@mui/icons-material/PushPin";
import QrCodeIcon from "@mui/icons-material/QrCode";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import QuizIcon from "@mui/icons-material/Quiz";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUncheckedOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReplayIcon from "@mui/icons-material/Replay";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ReplyIcon from "@mui/icons-material/ReplyOutlined";
import RocketLaunchOutlined from "@mui/icons-material/RocketLaunchOutlined";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSendOutlined";
import SchoolIcon from "@mui/icons-material/SchoolOutlined";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import SendIcon from "@mui/icons-material/SendOutlined";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutralOutlined";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfiedOutlined";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfiedOutlined";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfiedOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import ShareIcon from "@mui/icons-material/IosShare";
import ShortTextIcon from "@mui/icons-material/ShortText";
import SmilingFaceFilledIcon from "@mui/icons-material/EmojiEmotions";
import SortIcon from "@mui/icons-material/Sort";
import SouthWestIcon from "@mui/icons-material/SouthWest";
import SubdirectoryArrowRight from "@mui/icons-material/SubdirectoryArrowRight";
import SwapHorizOutlined from "@mui/icons-material/SwapHorizOutlined";
import ThumbDownOffAlt from "@mui/icons-material/ThumbDownOffAlt";
import ThumbsUpDownOutlined from "@mui/icons-material/ThumbsUpDownOutlined";
import TrendingDown from "@mui/icons-material/TrendingDown";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import UnfoldLessOutlinedIcon from "@mui/icons-material/UnfoldLessOutlined";
import UploadIcon from "@mui/icons-material/FileUploadOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import ViewAgendaOutlinedIcon from "@mui/icons-material/ViewAgendaOutlined";
import ViewListIcon from "@mui/icons-material/ViewListOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import WarningIcon from "@mui/icons-material/ReportProblemOutlined";

const SmilingFaceOutlinedIcon = SentimentVerySatisfiedIcon;
const BrightOutlineIcon = TipsAndUpdatesOutlinedIcon;

export {
    AccountIcon,
    AddCircleOutlineIcon,
    AddIcon,
    AlarmIcon,
    AllInclusiveIcon,
    AnnouncementOutlinedIcon,
    ArrowDownwardIcon,
    ArrowDropDownIcon,
    ArrowDropUpIcon,
    ArrowUpwardIcon,
    AssignedIcon,
    AssignmentTurnedInOutlined,
    AssistantOutlinedIcon,
    AutoAwesomeIcon,
    BadgeIcon,
    BarChartIcon,
    BookmarkIcon,
    BookmarkIconOutlined,
    BrightOutlineIcon,
    CampaignOutlinedIcon,
    CancelIcon,
    CategoryIcon,
    CalendarMonthOutlinedIcon,
    ChatIcon,
    ChatBubbleIcon,
    CheckBoxCheckedIcon,
    CheckBoxIcon,
    CheckBoxOutlinedIcon,
    CheckCircleOutlinedIcon,
    CheckIcon,
    ChecklistIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    CircleBlank,
    CircleChecked,
    CircleIcon,
    CloseIcon,
    CloseOutlinedIcon,
    ContentCopyIcon,
    DashboardOutlined,
    DataUsageIcon,
    DeleteIcon,
    DeleteOutlineIcon,
    DesktopWindowsOutlinedIcon,
    DownloadIcon,
    DoNotDisturbAltIcon,
    DraftsOutlinedIcon,
    DragHandleIcon,
    DragIndicatorIcon,
    DynamicFormOutlinedIcon,
    EditNoteIcon,
    EditIcon,
    EmailIcon,
    EndDateIcon,
    EngineeringIcon,
    ErrorIcon,
    ExpandMoreIcon,
    ExpandLessIcon,
    FactCheckOutlinedIcon,
    FavoriteBorderIcon,
    FiberManualRecord,
    FilterListIcon,
    FormatItalicIcon,
    FormatBoldIcon,
    GlobeIcon,
    GridIcon,
    GroupIcon,
    HandshakeIcon,
    HelpIcon,
    ImageOutlinedIcon,
    IndeterminateCheckBoxIcon,
    InsertChartIcon,
    InfoIcon,
    LeaderboardIcon,
    LinearScaleRoundedIcon,
    LinkIcon,
    ListOutlined,
    Lock,
    LockOpen,
    LockOpenOutlined,
    LockOutlined,
    LoopOutlined,
    LogoutIcon,
    MarkEmailReadOutlinedIcon,
    MoreVertIcon,
    NoChangeIcon,
    NorthWestIcon,
    NoteIcon,
    NotificationIcon,
    NotificationsActiveOutlinedIcon,
    OpenBookIcon,
    PauseIcon,
    PersonAddIcon,
    PersonRemoveIcon,
    PhoneIcon,
    PushPinIcon,
    PushPinFilledIcon,
    QrCodeIcon,
    QuestionAnswerOutlinedIcon,
    QuestionMarkIcon,
    QuizIcon,
    RadioButtonCheckedIcon,
    RadioButtonUncheckedIcon,
    RefreshIcon,
    RemoveCircleOutlineIcon,
    ReplayIcon,
    ReplyIcon,
    RocketLaunchOutlined,
    SaveIcon,
    ScheduleSendIcon,
    SchoolIcon,
    SearchIcon,
    SendIcon,
    SentimentDissatisfiedIcon,
    SentimentNeutralIcon,
    SentimentSatisfiedIcon,
    SentimentVeryDissatisfiedIcon,
    SentimentVerySatisfiedIcon,
    SettingsIcon,
    ShareIcon,
    ShortTextIcon,
    SmilingFaceFilledIcon,
    SmilingFaceOutlinedIcon,
    SortIcon,
    SouthWestIcon,
    SubdirectoryArrowRight,
    SwapHorizOutlined,
    ThumbDownOffAlt,
    ThumbsUpDownOutlined,
    TrendingDown,
    TimerOutlinedIcon,
    UnfoldLessOutlinedIcon,
    UploadIcon,
    VerifiedOutlinedIcon,
    ViewAgendaOutlinedIcon,
    ViewListIcon,
    VisibilityOffOutlinedIcon,
    VisibilityOutlinedIcon,
    WarningIcon,
};
